module.exports = __webpack_public_path__ + "static/img/gzh_code.e1fba6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gzh_code.jpg
// module id = CuNo
// module chunks = 1